/**
 * Layout: Theme
 * -----------------------------------------------------------------------------
 * Entry file for all global theme scripts.
 *
 */
import '@/layout/theme.scss'

/**
 * Core scripts.
 */
import '~/core/lazysizes'
import AppHandler from '~/core/app-handler'
import Bugsnag from '~/core/bugsnag'
import Canvas from '~/core/canvas'
import Commands from '~/core/commands'
import DomReady from '~/core/dom-ready'
import EventBus from '~/core/event-bus'
import Query from '~/core/query'
import TagHandler from '~/core/tag-handler'

/**
 * Global Canvas functions.
 */
window.cnvs = window.cnvs || {}
window.cnvs.DomReady = (callback) => DomReady(callback)
window.cnvs.EventBus = EventBus()
window.cnvs.Helpers = Commands().cli()
window.cnvs.Query = (query) => Query(query)

/**
 * DOM ready.
 */
cnvs.DomReady(() => {
  Bugsnag().init()
  Commands().init()

  AppHandler().beforeVueInit()
  TagHandler().init()
  Canvas().init()
  AppHandler().afterVueInit()
})
